import { PageHeader } from "../../common/form-elements";

const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded-md ${className}`} />
);

const AddProjectPropertyPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background font-poppins">
      {/* Static Header */}
      <PageHeader title="Loading Project..." />

      <div className="max-full mx-auto px-4 md:px-6 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* LEFT COLUMN */}
          <div className="space-y-6">
            {/* Project Name */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-40 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Video Upload Section */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-44 mb-3" />
              <Skeleton className="h-48 w-full rounded-lg" />
            </div>

            {/* Image Upload Section */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-60 mb-3" />
              <Skeleton className="h-56 w-full rounded-lg" />
            </div>

            {/* Brochure Upload */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-36 mb-3" />
              <Skeleton className="h-24 w-full rounded-lg" />
            </div>

            {/* Description */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-48 mb-3" />
              <Skeleton className="h-32 w-full rounded-lg" />
            </div>
          </div>

          {/* MIDDLE COLUMN */}
          <div className="space-y-6">
            {/* Facilities */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-44 mb-4" />
              <Skeleton className="h-10 w-full mb-2" />
              <Skeleton className="h-10 w-full mb-2" />
              <Skeleton className="h-8 w-24" />
            </div>

            {/* Specification */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-52 mb-3" />
              <Skeleton className="h-24 w-full rounded-lg mb-3" />
              <Skeleton className="h-10 w-32" />
            </div>

            {/* Floor Details */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-36 mb-4" />
              <div className="grid grid-cols-2 gap-2">
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
              </div>
            </div>

            {/* Floor Plan */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-36 mb-4" />
              <Skeleton className="h-48 w-full rounded-lg" />
            </div>

            {/* Builder Name */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-40 mb-4" />
              <Skeleton className="h-10 w-full" />
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="space-y-6">
            {/* Availability */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-44 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Ownership */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-36 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Amenities */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-40 mb-3" />
              <Skeleton className="h-10 w-full mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Payment Schedule */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-44 mb-3" />
              <Skeleton className="h-24 w-full rounded-lg mb-3" />
              <Skeleton className="h-8 w-28" />
            </div>

            {/* Price */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-28 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Brokerage */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-28 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Location */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Skeleton className="h-6 w-32 mb-3" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Submit BTN */}
            <Skeleton className="h-12 w-full rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProjectPropertyPageSkeleton;
